import React, { Component } from 'react';
import { Button, Grid, Paper } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import i18n from '../i18n';

import '../assets/stylesheets/Setting.css';

class GenericConfirmActionModal extends Component {
  handleConfirm = () => {
    const { onConfirm } = this.props;
    onConfirm();
  };

  render() {
    const {
      showModal,
      onClose,
      confirmMessage,
      confirmTitle
    } = this.props;

    return (
      <Modal open={showModal} onClose={onClose}>
        <Paper className="deleteModal">
          <Grid container>
            <Grid item xs={12}>
              <span>
                <h3>{confirmTitle}</h3>
              </span>
              <br />
              <span>
                <h4>{confirmMessage}</h4>
              </span>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={this.handleConfirm}
                className="ssenseButton ssensePrimary"
              >
                {i18n.t('confirm')}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={onClose}
                className="ssenseButton ssenseDefault"
              >
                {i18n.t('cancel')}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    );
  }
}

GenericConfirmActionModal.defaultProps = {
  confirmTitle: i18n.t('areYouSure'),
}

GenericConfirmActionModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  confirmMessage: PropTypes.string.isRequired,
  confirmTitle: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
};

export default GenericConfirmActionModal;
